<template>
  <div v-if="diff">
    <span
      v-for="(chunk, index) in chunks"
      :key="`text-${index}`"
      :class="{
        'green lighten-4': chunk.added,
        'red lighten-4': chunk.removed,
      }"
      >{{ chunk.value }}</span
    >
  </div>
</template>
<script>
import Vue from 'vue'
export default Vue.extend({
  props: {
    'diff': {
      type: Array,
      default: null,
    },
    'showRemoved': {
      type: Boolean,
      default: true,
    },
    'showAdded': {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    chunks() {
      return this.diff.filter(
        x =>
          (this.showAdded && x.added) ||
          (this.showRemoved && x.removed) ||
          (x.removed == null && x.added == null),
      )
    },
  },
})
</script>
